/* tslint:disable */
/* eslint-disable */
/**
 * Areeb Supplier API
 * Areeb Supplier REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  RecordSupplierResponseDto,
  SupplierBatchDto,
  SupplierBatchListResponseDto,
} from '../models/index';
import {
    RecordSupplierResponseDtoFromJSON,
    RecordSupplierResponseDtoToJSON,
    SupplierBatchDtoFromJSON,
    SupplierBatchDtoToJSON,
    SupplierBatchListResponseDtoFromJSON,
    SupplierBatchListResponseDtoToJSON,
} from '../models/index';

export interface GetMyBatchByIdRequest {
    id: string;
}

export interface GetMyBatchesRequest {
    status?: GetMyBatchesStatusEnum;
    page?: number;
    pageSize?: number;
}

export interface RecordResponseRequest {
    id: string;
    recordSupplierResponseDto: RecordSupplierResponseDto;
}

/**
 * 
 */
export class SourcingServiceApi extends runtime.BaseAPI {

    /**
     * Get a sourcing batch I own (aggregated lines)
     */
    async getMyBatchByIdRaw(requestParameters: GetMyBatchByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierBatchDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getMyBatchById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/sourcing/batch/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierBatchDtoFromJSON(jsonValue));
    }

    /**
     * Get a sourcing batch I own (aggregated lines)
     */
    async getMyBatchById(requestParameters: GetMyBatchByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierBatchDto> {
        const response = await this.getMyBatchByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List sourcing batches sent to me (excludes PENDING_REVIEW — admin still staging)
     */
    async getMyBatchesRaw(requestParameters: GetMyBatchesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierBatchListResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/sourcing/batch`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierBatchListResponseDtoFromJSON(jsonValue));
    }

    /**
     * List sourcing batches sent to me (excludes PENDING_REVIEW — admin still staging)
     */
    async getMyBatches(requestParameters: GetMyBatchesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierBatchListResponseDto> {
        const response = await this.getMyBatchesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Record my response for one or more lines (confirmed qty/price/unavailable/notes)
     */
    async recordResponseRaw(requestParameters: RecordResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SupplierBatchDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling recordResponse().'
            );
        }

        if (requestParameters['recordSupplierResponseDto'] == null) {
            throw new runtime.RequiredError(
                'recordSupplierResponseDto',
                'Required parameter "recordSupplierResponseDto" was null or undefined when calling recordResponse().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("access-token", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/supplier/sourcing/batch/{id}/lines`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: RecordSupplierResponseDtoToJSON(requestParameters['recordSupplierResponseDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SupplierBatchDtoFromJSON(jsonValue));
    }

    /**
     * Record my response for one or more lines (confirmed qty/price/unavailable/notes)
     */
    async recordResponse(requestParameters: RecordResponseRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SupplierBatchDto> {
        const response = await this.recordResponseRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetMyBatchesStatusEnum = {
    PendingReview: 'PENDING_REVIEW',
    SentToSupplier: 'SENT_TO_SUPPLIER',
    SupplierResponded: 'SUPPLIER_RESPONDED',
    ChangesPropagated: 'CHANGES_PROPAGATED',
    Completed: 'COMPLETED'
} as const;
export type GetMyBatchesStatusEnum = typeof GetMyBatchesStatusEnum[keyof typeof GetMyBatchesStatusEnum];
